import { SelectedMenu } from 'rangeConfig/@types';
import addInteriorToTarget from 'rangeConfig/billy/behaviours/addInteriorToTarget';
import { CoreApi, ProductType } from '@inter-ikea-storageone/range';
import hideDoors from 'rangeConfig/shared/behaviors/hideDoors';
import { matchDimensions } from 'rangeConfig/shared/filters/selectedMenuProductFilters';
import platform from 'rangeConfig/shared/utils/platform';
import DimensionsLabel from 'rangeConfig/shared/widgets/DimensionsLabel';
import deleteProduct from 'rangeConfig/shared/behaviors/deleteProduct';
import replaceFrame from 'rangeConfig/billy/behaviours/replaceFrame';
import {
  filterDeskType,
  filterDoorHeights,
  filterDoorType,
  filterInteriorColors,
  filterInteriorDimensions
} from 'rangeConfig/billy/filters/selectedMenuProductFilters';
import showDoors from 'rangeConfig/shared/behaviors/showDoors';
import { addDoors } from 'rangeConfig/billy/behaviours/addDoors';
import { noProductsWithTypesInScene } from 'rangeConfig/shared/rules/noneOptionSelectedRules';
import checkWidget from 'rangeConfig/shared/widgets/checkWidget';
import { SolutionDepthToggle } from 'rangeConfig/billy/widgets/ChangeFrameDepth/ChangeFrameDepth';
import { findMatchingFrameWithDifferentDepth } from 'rangeConfig/billy/utils/findMatchingFrameWithDifferentDepth';
import { hideDoorsFromSelectedFramesMenu } from 'rangeConfig/billy/rules/hideMenuRules';
import dragAndDropDoorsBehavior from 'rangeConfig/billy/behaviours/dragAndDropDoors';
import removeDoorsFromSelectedEntity from 'rangeConfig/shared/behaviors/removeDoorsFromSelectedEntity';

const widgets = {
  desktop: [
    {
      id: 'display-size',
      title: 'storageone.sizeFilterLabel',
      component: DimensionsLabel
    },
    {
      id: 'change-size',
      component: checkWidget(SolutionDepthToggle),
      title: 'storageone.depth',
      hidden: (coreApi: CoreApi) => !findMatchingFrameWithDifferentDepth(coreApi)
    },
    {
      id: 'frames-selected-menu-frames',
      title: 'storageone.productListFramesTitle',
      cardsSubtitle: 'designText, communicatedSizeText',
      behaviors: {
        productClicked: [replaceFrame],
        productDropped: [replaceFrame]
      },
      productFilters: [matchDimensions]
    },
    {
      id: 'frames-selected-menu-doors',
      title: 'storageone.productListDoorsTitle',
      cardsTitle: 'name',
      cardsSubtitle: 'typeName, designText',
      productThumbToolTip: 'typeName, designText',
      behaviors: {
        productClicked: [addDoors, showDoors],
        productDropped: [dragAndDropDoorsBehavior, showDoors]
      },
      productTypes: [ProductType.BILLY_DOOR_ASM],
      productFilters: [filterDoorHeights, filterDoorType],
      sortOrder: [{ path: 'communicatedDimensions.height', reverse: true }],
      noneOption: {
        title: 'storageone.productListNoHingedDoorsOptionTitle',
        subtitle: 'storageone.productListNoHingedDoorsOptionSubtitle',
        behaviors: { removeProducts: [removeDoorsFromSelectedEntity] },
        selected: noProductsWithTypesInScene([ProductType.BILLY_DOOR_ASM])
      },
      hidden: (coreApi: CoreApi) => hideDoorsFromSelectedFramesMenu(coreApi)
    },
    {
      id: 'frames-selected-menu-interiors',
      title: 'storageone.productListInteriorsTitle',
      productThumbToolTip: 'typeName, designText',
      behaviors: {
        productClicked: [hideDoors, addInteriorToTarget],
        productDropped: [hideDoors, addInteriorToTarget]
      },
      productTypes: [ProductType.BILLY_SHELF, ProductType.BILLY_DRAWER, ProductType.BILLY_DESK],
      productFilters: [filterInteriorDimensions, filterInteriorColors, filterDeskType]
    }
  ],
  mobile: [
    {
      id: 'frames-selected-menu-frames',
      title: 'storageone.productListFramesTitle',
      behaviors: {
        productClicked: [replaceFrame],
        productDropped: [replaceFrame]
      },
      productFilters: [matchDimensions]
    }
  ]
};

const selectedMenu: SelectedMenu = {
  menuTitle: 'storageone.selectedProductListCustomiseBookcase',
  behaviors: {
    productDeleted: [deleteProduct]
  },
  content: widgets[platform]
};

export default selectedMenu;
